<template lang="pug">
  v-container(fluid)
    h1 Social Media
    Facebook
    Twitter
</template>

<script>
import Facebook from './facebook';
import Twitter from './twitter';
export default {
  components: {
    Facebook,
    Twitter
  }
};
</script>

<style lang="stylus" scoped></style>
